import ApiConnection from "../ApiConnection";

export const post = (body: {username: string, password: string}) => {
    return ApiConnection.post('/sessions', body)
};
